import { useEffect, useRef } from 'react'
import { useAuth } from '../../shared/auth/auth-context'
import { applyRemoteTheme, savedThemeChoice } from '../../shared/theme/theme'
import { useProfile, useSetTheme } from './queries'

export function useThemeSync() {
  const { status } = useAuth()
  const profile = useProfile(status === 'authenticated')
  const { mutate } = useSetTheme()
  const synced = useRef(false)
  const loaded = profile.data

  useEffect(() => {
    if (status !== 'authenticated') synced.current = false
    if (!loaded || synced.current) return
    synced.current = true
    if (loaded.theme) {
      applyRemoteTheme(loaded.theme)
      return
    }
    const local = savedThemeChoice()
    if (local) mutate(local)
  }, [status, loaded, mutate])
}
